import axios from 'axios';

import constants from 'constants/constants';

export const actions = {
  fetchLabels: 'FETCH_LABELS',
  fetchLabelsSuccess: 'FETCH_LABELS_SUCCESS',
  fetchLabelsError: 'FETCH_LABELS_ERROR',
  initLabels: 'INITIALIZE_LABELS'
};

export const fetchLabels = flowId => (dispatch) => {
  dispatch({
    type: actions.fetchLabels
  });

  const url = `${constants.labelEndpoint}/${flowId}`;

  axios.get(url)
    .then((res) => {
      dispatch({
        type: actions.fetchLabelsSuccess,
        payload: res.data
      });
    })
    .catch((err) => {
      dispatch({
        type: actions.fetchLabelsError,
        payload: err
      });
    });
};

export const initLabels = data => (dispatch) => {
  dispatch({
    type: actions.initLabels,
    payload: data
  });
};



// WEBPACK FOOTER //
// ./src/actions/labels.js